/**
 * 객체에서 undefined 값을 제거하는 유틸 함수
 *
 * API 요청 시 undefined 값을 제거하여 불필요한 파라미터를 전송하지 않도록 합니다.
 *
 * Origin: PageNicolasApi.ts의 trimUndefinedFromObject
 *
 * @example
 * ```ts
 * trimUndefinedFromObject({a: 1, b: undefined, c: 'test'})
 * // => {a: 1, c: 'test'}
 * ```
 */
export function trimUndefinedFromObject(obj: {[key: string | number]: any}): {
  [key: string | number]: any;
} {
  return Object.keys(obj).reduce(
    (acc, key) => {
      if (obj[key] !== undefined) acc[key] = obj[key];
      return acc;
    },
    {} as {[key: string | number]: any}
  );
}
